/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_TestInputs */

const vi_einvoice_credential_test = /** @type {(inputs: Einvoice_Credential_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra kết nối`)
};

/**

* @param {Einvoice_Credential_TestInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_test = /** @type {((inputs?: Einvoice_Credential_TestInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_TestInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_test(inputs)
});